import { Image, Inspector, Flex } from '@sequencehq/core-components'
import { FC } from 'react'
import { hubSpotIntegrationConfig } from '../hubspot.integration.config'
import { LinkCustomerToServiceWidget } from '../../common/LinkEntities/LinkCustomerToService'
import { useLinkCustomerToService } from '../../common/LinkEntities/LinkCustomerToService/LinkCustomerToServiceWidget/useLinkCustomerToService'
import { useIntegrationActive } from 'Integrations/utils/useIntegrationActive'
import { SmallIcon } from 'Integrations/integrationsConfig/common/SmallIcon'
import { useIntegrationAuthError } from 'Integrations/utils/useIntegrationAuthError'
import { NotAuthenticatedItemContent } from 'Integrations/integrationsConfig/common/NotAuthenticatedItemContent'

export const HubspotInspectorItem: FC<{
  children: React.ReactNode
}> = props => {
  const integrationActive = useIntegrationActive('HubSpot')
  const integrationAuthError = useIntegrationAuthError('HubSpot')

  if (!integrationActive && !integrationAuthError) {
    return null
  }

  return (
    <Inspector.IconItem
      data-testid="hubspot.inspector.item"
      content={
        integrationAuthError ? (
          <NotAuthenticatedItemContent
            service="HubSpot"
            data-testid="hubspot.inspector.content.unauth"
            serviceDescription={hubSpotIntegrationConfig.description}
            serviceName={hubSpotIntegrationConfig.title}
            logo={
              <Image
                src={hubSpotIntegrationConfig.smallLogoUrl}
                height="24px"
                width="24px"
              />
            }
          />
        ) : (
          <Inspector.Content
            title="HubSpot"
            data-testid="hubspot.inspector.content"
            icon={<SmallIcon url={hubSpotIntegrationConfig.smallLogoUrl} />}
          >
            <Flex flexDirection="column" gap="16px">
              {props.children}
            </Flex>
          </Inspector.Content>
        )
      }
      tooltip="HubSpot"
      icon={<SmallIcon url={hubSpotIntegrationConfig.smallLogoUrl} />}
    />
  )
}

export const LinkHubSpotCustomerWidget: FC<{
  customerId: string
  canLink?: boolean
  canUnlink?: boolean
}> = props => {
  const hasCustomer = Boolean(props.customerId)

  const customerLink = useLinkCustomerToService({
    customerId: props.customerId,
    service: 'HubSpot',
    enabled: hasCustomer
  })

  const linkPrompt = customerLink.customerName
    ? `Link ${customerLink.customerName} to a HubSpot company`
    : undefined

  return (
    <LinkCustomerToServiceWidget
      customerId={props.customerId}
      service="HubSpot"
      canLink={props.canLink}
      canUnlink={props.canUnlink}
      externalEntityLabel="company"
      sequenceEntityLabel="customer"
      noLinkFoundText={
        hasCustomer
          ? linkPrompt
          : 'Select a customer to enable HubSpot company linking'
      }
    />
  )
}
